<template>
  <tr>
    <td data-label="Name">
      <strong>
        {{ staff.dropdownLabel }}
        <br />
        <em v-if="staff.AccountType.role === 'Admin'">
          (admin)
        </em>
      </strong>
    </td>
    <td data-label="Email">
      {{ staff.email }}
    </td>
    <td data-label="Phone">
        {{ staff.mobilePhone ? staff.mobilePhone : 'N/A' }}
    </td>
    <td data-label="Address">
        {{ staff.address ? staff.address : 'N/A' }}
    </td>
    <td class="button-3 text-center">
      <button class="my-2 btn btn-warning" @click="editStaffMember()">
        <i class="fa fa-edit" /> Edit
      </button>
      <button class="my-2 btn btn-danger" @click="deleteStaffMember()">
        <i class="fa fa-trash" /> Delete
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'StaffRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    phone () {
      if (this.staff.phone) {
        return this.staff.phone.replace(/\D/g, '')
      } else {
        return ''
      }
    },
    staff () {
      return {
        AccountType: {},
        ...this.object
      }
    }
  },
  methods: {
    editStaffMember () {
      this.$emit('edit', { permalink: 'editStaff', uuid: this.staff.uuid })
    },
    deleteStaffMember () {
      this.$emit('deleteObject', { permalink: 'deleteStaff', uuid: this.staff.uuid })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/StaffRow.vue